module.exports = __webpack_public_path__ + "static/media/AnimalWelfare.efb4eee9.svg";